export const ACCORD_IMMI_URL = "https://www.accord-immi.moj.go.jp/accord-u/profile/userLogin";
